import $ from "jquery";

// select with grey background "services" menu item when clicking on one of the three badges on below header banner
export default function selecteServiceMenuItem() {
    $(".nav-collapse ul.nav li").removeClass("active");
    $("li.dropdown ul li a").parent().parent().parent().addClass("active");
}